import type { KeypadIssue } from './catalog/issue';

/**
 * Outcome of an edit to the keypad book.
 *
 * The same shape as the configuration's `Result`, kept separate on purpose: a
 * refusal here has to carry a keypad issue, so the two can never be confused.
 */
export type KeypadResult<T> =
  | { readonly ok: true; readonly value: T }
  | { readonly ok: false; readonly issue: KeypadIssue };

export const ok = <T>(value: T): KeypadResult<T> => ({ ok: true, value });

export const fail = (issue: KeypadIssue): KeypadResult<never> => ({ ok: false, issue });
